import { useRef, useEffect, useState } from 'react';
import { draggable, dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

export function useFormFieldDragDrop({ fieldId, index, onReorder }) {
  const fieldRef = useRef(null);
  const dragHandleRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [isOver, setIsOver] = useState(false);

  useEffect(() => {
    const el = fieldRef.current;
    const handleEl = dragHandleRef.current;
    if (!el || !handleEl) return undefined;

    const cleanupDraggable = draggable({
      element: el,
      dragHandle: handleEl,
      getInitialData: () => ({ fieldId, index, type: 'form-field' }),
      onDragStart: () => setIsDragging(true),
      onDrop: () => setIsDragging(false),
    });

    const cleanupDropTarget = dropTargetForElements({
      element: el,
      canDrop: ({ source }) => source.data.type === 'form-field',
      getData: () => ({ fieldId, index }),
      onDragEnter: () => setIsOver(true),
      onDragLeave: () => setIsOver(false),
      onDrop: ({ source, self }) => {
        setIsOver(false);
        const sourceIndex = source.data.index;
        const destIndex = self.data.index;
        if (sourceIndex !== destIndex) {
          onReorder(sourceIndex, destIndex);
        }
      },
    });

    return () => {
      cleanupDraggable();
      cleanupDropTarget();
    };
  }, [fieldId, index, onReorder]);

  return { fieldRef, dragHandleRef, isDragging, isOver };
}
